/* @flow */

/*
 * this is a little temporary store for the expert opinions of the
 * currently checkedout poll.
 * changes made to this are usually committed to the main stores
 * once a poll has been saved to the server.
 */

import update from 'react-addons-update'
import findIndex from 'lodash/findIndex'

import type {
  RootState,
  FluxStandardAction,
  ExpertOpinion,
  Vector,
} from '../types'

import { ActionRequiresPropertyError } from '../helpers'

import { CHECKOUT_NEW_POLL } from './pollBuilder'

export const STATE_KEY = 'pollBuilderCheckedoutExpertOpinions'

export const CHECKOUT_EXISTING_POLL_EXPERT_OPINIONS =
  'opinary/CHECKOUT_EXISTING_POLL_EXPERT_OPINIONS'
export const INSERT_CHECKEDOUT_EXPERT_OPINION =
  'opinary/INSERT_CHECKEDOUT_EXPERT_OPINION'
export const UPDATE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX =
  'opinary/UPDATE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX'
export const DELETE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX =
  'opinary/DELETE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX'
export const MOVE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX =
  'opinary/MOVE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX'

export function checkoutExistingPollExpertOpinions(
  items: Array<ExpertOpinion>
): FluxStandardAction {
  return {
    type: CHECKOUT_EXISTING_POLL_EXPERT_OPINIONS,
    payload: items,
  }
}

export function insertCheckedoutExpertOpinion(
  item: ExpertOpinion
): FluxStandardAction {
  return {
    type: INSERT_CHECKEDOUT_EXPERT_OPINION,
    payload: item,
  }
}

export function updateCheckedoutExpertOpinionWhereIndex(
  id: string,
  changes: Object
): FluxStandardAction {
  return {
    type: UPDATE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX,
    payload: {
      id,
      changes,
    },
  }
}

export function deleteCheckedoutExpertOpinionWhereIndex(
  id: string
): FluxStandardAction {
  return {
    type: DELETE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX,
    payload: id,
  }
}

export function moveCheckedoutExpertOpinionWhereIndex(
  index: number,
  position: Vector
): FluxStandardAction {
  return {
    type: MOVE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX,
    payload: {
      index,
      position,
    },
  }
}

export function selectCheckedoutExpertOpinions(
  state: RootState
): Array<ExpertOpinion> {
  return state[STATE_KEY]
}

export function selectCheckedoutExpertOpinionWhereIndex(
  state: RootState,
  index: number
): ?ExpertOpinion {
  const expertOpinions = selectCheckedoutExpertOpinions(state)
  return expertOpinions[index]
}

export default function reducer(
  state: Array<ExpertOpinion> = [],
  action: FluxStandardAction
) {
  const { payload } = action
  switch (action.type) {
    case CHECKOUT_EXISTING_POLL_EXPERT_OPINIONS:
      if (!action.payload) {
        throw new ActionRequiresPropertyError(
          CHECKOUT_EXISTING_POLL_EXPERT_OPINIONS,
          'payload'
        )
      }
      return action.payload
    case CHECKOUT_NEW_POLL:
      return []
    case INSERT_CHECKEDOUT_EXPERT_OPINION:
      if (payload == null) {
        throw new ActionRequiresPropertyError(
          INSERT_CHECKEDOUT_EXPERT_OPINION,
          'payload'
        )
      }
      return update(state, {
        $push: [payload],
      })
    case UPDATE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX:
      if (!payload || payload.changes === null || payload.id === null) {
        throw new ActionRequiresPropertyError(
          UPDATE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX,
          'changes',
          'id'
        )
      }

      const index = findIndex(state, { id: payload.id })

      if (state[index] == null) {
        throw new Error(`there is no expert opinion with id ${payload.id}`)
      }

      return update(state, {
        [index]: { $merge: payload.changes },
      })
    case DELETE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX: {
      if (!payload) {
        throw new ActionRequiresPropertyError(
          DELETE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX,
          'id'
        )
      }

      const targetIndex = findIndex(state, { id: payload })

      if (state[targetIndex] == null) {
        throw new Error(`there is no expert opinion with id ${payload}`)
      }

      return state.filter((item, index) => {
        return index !== targetIndex
      })
    }
    case MOVE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX:
      if (!payload || payload.position == null || payload.index == null) {
        throw new ActionRequiresPropertyError(
          UPDATE_CHECKEDOUT_EXPERT_OPINION_WHERE_INDEX,
          'position',
          'index'
        )
      }
      if (state[payload.index] == null) {
        throw new Error(
          `there is no expert opinion with index ${payload.index}`
        )
      }
      return update(state, {
        [payload.index]: { $merge: payload.position },
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/pollBuilderCheckedoutExpertOpinions.js